__turbopack_context__.v({
  "attribute": "CandidateCardStartup-module__YMibBW__attribute",
  "attributes": "CandidateCardStartup-module__YMibBW__attributes",
  "avatarBlurred": "CandidateCardStartup-module__YMibBW__avatarBlurred",
  "avatarFallback": "CandidateCardStartup-module__YMibBW__avatarFallback",
  "avatarImage": "CandidateCardStartup-module__YMibBW__avatarImage",
  "avatarWrapper": "CandidateCardStartup-module__YMibBW__avatarWrapper",
  "card": "CandidateCardStartup-module__YMibBW__card",
  "emoji": "CandidateCardStartup-module__YMibBW__emoji",
  "headings": "CandidateCardStartup-module__YMibBW__headings",
  "name": "CandidateCardStartup-module__YMibBW__name",
  "recruiterLogo": "CandidateCardStartup-module__YMibBW__recruiterLogo",
  "root": "CandidateCardStartup-module__YMibBW__root",
  "skillLogo": "CandidateCardStartup-module__YMibBW__skillLogo",
  "skillName": "CandidateCardStartup-module__YMibBW__skillName",
  "subtitle": "CandidateCardStartup-module__YMibBW__subtitle",
  "title": "CandidateCardStartup-module__YMibBW__title",
  "top": "CandidateCardStartup-module__YMibBW__top",
});
